import { BaseProduct } from '../types';

type GetMaterialTypesFromProducts = (products: BaseProduct[]) => string[];
type ProductHasMaterialOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForMaterial = (
  product: BaseProduct,
) => MaterialKey | null;
type ProductHasVariantWithMaterialType = (
  materialType: string,
) => (product: BaseProduct) => boolean;

type ProductHasVariantWithTransparencyType = (
  materialType: string,
) => (product: BaseProduct) => boolean;

type MaterialKey = 'option1' | 'option2' | 'option3';

export const getMaterialTypesFromProducts: GetMaterialTypesFromProducts = products => {
  const productsWithOption = products.filter(productHasMaterialOption);
  if (productsWithOption.length === 0) return [];

  const materialKey = getVariantOptionKeyForMaterial(productsWithOption[0]);
  if (materialKey === null) return [];

  const materials = productsWithOption
    .map(product => {
      return product.variants.map(variant => variant[materialKey]);
    })
    .flat()
    .filter(material => typeof material === 'string') as string[];

  return Array.from(new Set(materials));
};

export const productHasMaterialOption: ProductHasMaterialOption = product =>
  product.options.includes('Fabric Type');

export const getVariantOptionKeyForMaterial: GetVariantOptionKeyForMaterial = product => {
  const materialIndex = product.options.findIndex(
    option => option === 'Fabric Type' || option === 'Transparency',
  );
  if (materialIndex === -1) return null;

  return `option${materialIndex + 1}` as MaterialKey;
};

export const productHasVariantWithMaterialType: ProductHasVariantWithMaterialType = materialType => product => {
  const optionKey = getVariantOptionKeyForMaterial(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === materialType);
};

export const productHasVariantWithTransparencyType: ProductHasVariantWithTransparencyType = transparency => product => {
  const optionKey = getVariantOptionKeyForMaterial(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === transparency);
};
